import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { CustomerService } from '../services/customer.service';
import { CustomerFavoriteItemDTO } from '../models/customer.model';

@Injectable()
export class CustomerStore {
  private favoriteItemsSubject = new BehaviorSubject<string[]>([]);
  public readonly favoriteItems$ = this.favoriteItemsSubject.asObservable();

  constructor(private customerService: CustomerService) {}

  public loadFavoriteItems(customerId: string): void {
    this.customerService.getCustomerFavoriteItems(customerId).subscribe(
      (items) => this.favoriteItemsSubject.next(items),
      (error) => console.error('Error loading favorite items', error)
    );
  }

  public addFavoriteItem(customerId: string, favoriteItem: CustomerFavoriteItemDTO): void {
    this.customerService.saveCustomerFavoriteItem(customerId, favoriteItem).subscribe(
      () => this.loadFavoriteItems(customerId),
      (error) => console.error('Error saving favorite item', error)
    );
  }

  public removeFavoriteItem(customerId: string, itemId: string): void {
    this.customerService.deleteCustomerFavoriteItem(customerId, itemId).subscribe(
      () => this.loadFavoriteItems(customerId),
      (error) => console.error('Error deleting favorite item', error)
    );
  }

  public toggleFavoriteItem(itemId: string): void {
    const currentFavorites = this.favoriteItemsSubject.getValue();
    if (currentFavorites.includes(itemId)) {
      const updatedFavorites = currentFavorites.filter(item => item !== itemId);
      this.favoriteItemsSubject.next(updatedFavorites);
    } else {
      this.favoriteItemsSubject.next([...currentFavorites, itemId]);
    }
  }
}
